import './LastNameDisclaimerImportantMessage.scss';
import { formatText, HtmlText } from 'core/i18n';
import React from 'react';
import MessageBox from 'components/commons/MessageBox/MessageBox';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';

export const LastNameDisclaimerImportantMessage = ({ notAllowedProductKey }) => {
    return (
        <FeatureTogglingRender notAllowedProductKey={notAllowedProductKey}>
            <div className={'col-sm-12 last-name-disclaimer'}>
                <MessageBox
                    boxColor="yellow"
                    iconColor="warning-yellow"
                    titleText={formatText('initial-lastNameDisclaimerImportantMessage')}
                    contentText={HtmlText(formatText('initial-lastNameDisclaimer'))}
                />
            </div>
        </FeatureTogglingRender>
    );
};
